import type { Route } from '@angular/router';
import { FrontOfficeEnergySourceResolverService } from '@frontoffice/statistics/domain';

export const statisticsOverviewListRoutes: Route = {
  path: 'statistics',
  loadComponent: () =>
    import('../statistics-overview-list/statistics-overview-list.component').then(
      (mod) => mod.StatisticsOverviewListComponent,
    ),
};

export const statisticsOverviewRoutes: Route[] = [
  {
    path: 'statistics/power/contracts-review/:companyId/year/:year',
    loadComponent: () =>
      import('../statistics-overview/statistics-overview.component').then(
        (mod) => mod.StatisticsOverviewComponent,
      ),
    resolve: {
      energySource: FrontOfficeEnergySourceResolverService,
    },
  },
  {
    path: 'statistics/gas/contracts-review/:companyId/year/:year',
    loadComponent: () =>
      import('../statistics-overview/statistics-overview.component').then(
        (mod) => mod.StatisticsOverviewComponent,
      ),
    resolve: {
      energySource: FrontOfficeEnergySourceResolverService,
    },
  },
];
